// extracted by mini-css-extract-plugin
export default {"policyContainer":"rate_plan_policies_policyContainer__yZ-OQ","policyCell":"rate_plan_policies_policyCell__keyii","mealContainer":"rate_plan_policies_mealContainer__MiIfT"};